import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tasksAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';
import { fromHM } from '../../utils/duration';

export default function AddTask() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '', description: '', priority: 'medium',
    expected_h: '', expected_m: '', deadline: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const payload = {
        title: form.title,
        description: form.description || null,
        priority: form.priority,
        expected_hours: fromHM(form.expected_h, form.expected_m),
        deadline: form.deadline ? new Date(form.deadline).toISOString() : null,
      };
      const { data } = await tasksAPI.create(payload);
      navigate(`/employee/tasks/${data.id}`);
    } catch (err) {
      setError(parseApiError(err, 'Failed to create task'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Add New Task</h2>
        <button className="btn btn-ghost" onClick={() => navigate(-1)}>← Back</button>
      </div>

      <div className="form-card">
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Task Title *</label>
            <input required value={form.title} onChange={set('title')} placeholder="Brief task title" />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea value={form.description} onChange={set('description')} rows={4} placeholder="Describe the task..." />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Priority</label>
              <select value={form.priority} onChange={set('priority')}>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="urgent">Urgent</option>
              </select>
            </div>
            <div className="form-group">
              <label>Expected Time</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input type="number" min="0" value={form.expected_h} onChange={set('expected_h')} placeholder="Hours" aria-label="Expected hours" />
                <input type="number" min="0" max="59" value={form.expected_m} onChange={set('expected_m')} placeholder="Minutes" aria-label="Expected minutes" />
              </div>
              <small className="field-hint">e.g. 2 hours 30 minutes</small>
            </div>
          </div>
          <div className="form-group">
            <label>Deadline</label>
            <input type="datetime-local" value={form.deadline} onChange={set('deadline')} />
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating...' : 'Create Task'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
